module.exports = __webpack_public_path__ + "static/media/Short_HD_background1.d789c162.mp4";